import { CLASS_OPEN } from '../tools/constants/classes';
import Vimeo from '@vimeo/player';

const getModalMarkup = (title, content, image, video) => {
  const template = document.createElement('template');

  template.innerHTML = `
    <style>
      :host {
        display: block;
      }

      .o-modal {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 70;
        display: block;
        pointer-events: none;
      }

      .o-modal.is-open {
        pointer-events: all;
      }

      .o-modal__close {
        position: absolute;
        top: -1rem;
        right: 1.25rem;
        display: flex;
        width: 2.5rem;
        height: 2.5rem;
        padding: .625rem;
        justify-content: center;
        align-items: center;
        background: white;
        cursor: pointer;
        border-radius: 50%;
        z-index: 2;
        border: none;
      }

      .o-modal__close svg {
        width: 100%;
      }

      .o-modal__inner {
        background: #F5F2F0;
        padding: 40px 20px;
        border-radius: 2rem 2rem 0 0;
        height: calc(100% - 5rem);
        overflow-y: auto;
        scrollbar-width: none;
      }

      .o-modal__inner h6 {
        margin-left: auto;
        margin-right: auto;
        text-align: center;
      }

      .o-modal__inner img {
        margin: 0 33px 0;
        width: calc(100% - 66px);
        border-radius: 20px;
      }

      .o-modal__inner p {
        font-family: TTNorms Font, Helvectica, sans-serif;
        font-weight: 400;
        line-height: 1;
        letter-spacing: 0;
        font-size: .875rem;
        line-height: 1.25rem;
        margin: 32px 0;
        text-align: left;
      }

      .o-modal__inner::-webkit-scrollbar {
        display: none;
      }
      
      .o-modal__inner-wrapper {
        position: absolute;
        top: 4.5rem;
        bottom: 0;
        width: 100%;
        z-index: 1;
        transition: transform 1.4s cubic-bezier(0.16, 1, 0.3, 1);
        display: none;
      }

      .is-open .o-modal__inner-wrapper {
        display: block;
      }

      .o-modal__title {
        margin: 0 0 1.5rem;
      }
    
      .is-text-center .o-modal__title {
        text-align: center;
      }
      
      .o-modal__overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        cursor: pointer;
        background: #3f73554d;
        transition: opacity 1.4s cubic-bezier(.16,1,.3,1);
        opacity: 0;
      }

      .is-open .o-modal__overlay {
        opacity: 1;
      }

      h6 {
        margin-top: 0;
        font-family: Recoleta, sans-serif;
        font-weight: 500;
        letter-spacing: 0;
        font-size: 1.125rem;
        line-height: 1.5rem;
        margin: 0 0 1.5rem;
      }

      .is-blank-paragraph {
        display: none;
      }

      .video-container {
        position: relative;
        padding-bottom: 56.25%;
        height: 0;
        overflow: hidden;
        margin-bottom: 2rem;
        border-radius: 20px;
      }

      .video-container p {
        display: none;
      }

      iframe {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        overflow: hidden;
      }

      .video-vimeo-container {
        position: relative;
        padding-bottom: 56.25%;
        height: 0;
        overflow: hidden;
        border-radius: 20px;
        cursor: pointer;
      }

      .video-vimeo-container iframe {
        pointer-events: none;
      }

      .video-container:hover .o-btn.is-play {
        background-color: #3F7355;
      }
      .video-container:hover .o-btn.is-play svg path {
        fill: #FCFCFB;
        stroke: #FCFCFB;
      }

      .video iframe {
        display: none;
      }

      .o-btn.is-play {
        width: 43px;
        height: 44px;
        background-color: #FCFCFB;
        border-radius: 50%;
        position: absolute;
        align-items: center;
        justify-content: center;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        border: none;
        display: none;
        align-items: center;
        justify-content: center;
        pointer-events: none;
        transition: all 1.4s cubic-bezier(0.16, 1, 0.3, 1);
      }

      .o-btn.is-play.is-visible {
        display: flex;
      }

      .o-btn.is-play svg {
        width: 13px;
        height: 13px;
      }

      .o-btn.is-play svg path {
        fill: #3F7355;
        stroke: #3F7355;
      }

      @media only screen and (min-width: 1100px) {
        .o-modal__inner-wrapper {
          top: 2.5rem;
          right: 2.5rem;
          height: calc(100% - 5rem);
          width: 29.375rem;
          bottom: unset;
        }

        .o-modal__inner {
          padding: 48px 40px;
          border-radius: 2.25rem;
          height: calc(100% - 6rem);
        }

        .o-modal__inner img {
          margin: 0 40px;
          width: calc(100% - 80px);
          border-radius: 24px;
        }

        .o-modal__inner p {
          font-size: 1rem;
          line-height: 1.5rem;
        }

        .is-open .o-modal__inner-wrapper {
          transform: translate(0);
        }

        h6 {
          font-size: 1.5rem;
          line-height: 2rem;
          margin-bottom: 2rem;
        }
      }

      @media only screen and (min-width: 1750px) {
        h6 {
          font-size: 2.5rem;
          line-height: 3rem;
        }

        .o-modal__inner {
          padding: 4rem 3rem 3rem;
          height: calc(100% - 7rem);
        }

        .o-modal__inner-wrapper {
          top: 3rem;
          right: 3rem;
          width: 38.5rem;
          height: calc(100% - 6rem);
        }

        .o-modal__inner h5 {
          font-size: 2.5rem;
          line-height: 3rem;
        }

        .o-modal__inner p {
          font-size: 1.25rem;
          line-height: 1.75rem;
        }

        .o-btn {
          letter-spacing: $s-font--letter-default;
          font-size: 1.25rem;
          line-height: 1.75rem;
          margin: 2.5rem 0 2rem;
        }

        .o-btn.is-play {
          margin: 0;
        }
      }
    }
    </style>

    <div class="o-modal is-open">
      <div class="o-modal__inner-wrapper">
        <button class="o-modal__close" data-modal-close="">
          <svg xmlns="http://www.w3.org/2000/svg" class="" fill="none" viewBox="0 0 22 22"><g stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"><path d="M17.188 4.813 4.813 17.188M17.188 17.188 4.813 4.813"></path></g></svg>
        </button>
        
        <div class="o-modal__inner">
          <h6>${title}</h6>
          ${image ? `<img src="${image}" alt="${title}">` : ''}
          <div class="o-modal__content">
            ${content}
            ${video ? `<p>${video}</p>` : ''}
          </div>
        </div>
      </div>
      <button class="o-modal__overlay" data-modal-close=""></button>
    </div>
  `;
  return template;
}

export class CustomiserModal extends HTMLElement {
  private heading:string|null = null;
  private content:any;
  private image:string|null = null;
  private video:string|null = null;
  private modal:HTMLElement|null = null;
  private close:NodeListOf<HTMLElement> | null = null;
  private videoIframe:any;
  private playButton:HTMLElement|null = null;
  private videoElement:HTMLElement|null = null;
  private newVideoPlayer:any;
  private modalContent:HTMLElement|null = null;

  constructor() {
    super();

    this.heading = this.getAttribute('title');
    this.content = this.getAttribute('content');
    this.image = this.getAttribute('image');
    this.video = this.getAttribute('video');

    if (!this.heading || !this.content) {
      console.error('Need to supply a modal content here!', this);
      return;
    }
    
    const shadowRoot = this.attachShadow({ mode: 'open' });
    // console.log(this.content);
    const template = getModalMarkup(this.title, this.content, this.image, this.video);
    shadowRoot.appendChild(template.content.cloneNode(true));

    if (this.shadowRoot) {
      this.close = this.shadowRoot.querySelectorAll('[data-modal-close]');

      this.modalContent = this.shadowRoot.querySelector('.o-modal__content');
      if (this.modalContent?.innerText.includes('iframe')) this.convertVideoSnippetToHTML();

      this.videoIframe = this.shadowRoot.querySelector('iframe');
      if (this.videoIframe) this.loadVideoData();
  
      this.close.forEach(button => {
        button.addEventListener('click', (e) => {
          this.setVisibility(false);
        });
      });
    }

    this.setVisibility(false);
  }

  convertVideoSnippetToHTML() {
    if (!this.modalContent) return;

    const paragraphs = this.modalContent.querySelectorAll('p');

    paragraphs?.forEach((paragraph) => {
      if (paragraph.innerHTML.includes('iframe')) {
        const rawContent = paragraph.innerHTML;
        const tempElement = document.createElement('div');
        tempElement.innerHTML = rawContent;
        const paragraphText = tempElement.textContent || tempElement.innerText;
    
        paragraph.classList.add('has-video');
        paragraph.innerHTML = `
          <div class="video-container">
            <div class="video">
              ${paragraphText}
            </div>
            <div class="video-vimeo-container"></div>
            <div class="video-thumbnail"></div>
            <button class="o-btn is-play is-visible" data-video-play>
              <svg class="" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 15"><path d="M13.15 6.665a.971.971 0 0 1 0 1.67L2.787 14.372c-.63.366-1.412-.097-1.412-.835V1.463c0-.738.783-1.201 1.412-.835L13.15 6.665Z" fill="#163021" stroke="#163021"></path></svg>
            </button>
          </div>`;
      }
    });
  }
  
  async loadVideoData() {
    if (!this.shadowRoot) return;
    
    this.videoElement = this.shadowRoot.querySelector('.video-vimeo-container');
    this.playButton = this.shadowRoot.querySelector('.is-play');
    
    try {
      if (this.videoIframe && this.videoElement && this.playButton) {
        let videoPlayer = new Vimeo(this.videoIframe);
        let vidId = await videoPlayer.getVideoId();

        const options = {
          loop: true,
          controls: false,
          id: vidId
        };
    
        this.newVideoPlayer = new Vimeo(this.videoElement,options);

        this.videoElement.addEventListener('click', (e) => {
          if (this.playButton?.classList.contains('is-visible')) {
            this.newVideoPlayer.play();
            this.playButton?.classList.remove('is-visible');
          } else {
            this.newVideoPlayer.pause();
            this.playButton?.classList.add('is-visible');
          }
        });
      }
    } catch (error) {
      console.error('Error:', error);
    }
  }

  public setVisibility(visibility:boolean) {
    if (!this.shadowRoot) return;

    this.modal = this.shadowRoot?.querySelector('.o-modal');
    if (!this.modal) return;
    
    if (visibility) {
      this.modal?.classList.add(CLASS_OPEN);
    } else {
      this.modal?.classList.remove(CLASS_OPEN);
      this.newVideoPlayer?.pause();
    }
  }
}

if (!customElements.get('customiser-modal')) {
  customElements.define('customiser-modal', CustomiserModal);
}